import {
    DisplayOrder,
    Number,
    SortDefault,
    String,
    TableDisplayedDefault
} from '@ui-kit/webkit/components/crud-item/crud-item-decorator';

export class CrudAtokuUser {
    id: string = '';

    @DisplayOrder(1)
    @TableDisplayedDefault
    @String('Card ID')
    cardId: string = 'NaN';

    @DisplayOrder(2)
    @TableDisplayedDefault
    @SortDefault('asc')
    @String('Name')
    name: string = '';

    @DisplayOrder(3)
    @TableDisplayedDefault
    @String('Surname')
    surname: string = '';

    @DisplayOrder(4)
    @TableDisplayedDefault
    @String('Email')
    email: string = 'NaN';

    @DisplayOrder(5)
    @TableDisplayedDefault
    @String('Pricing Profile')
    pricingProfileCode: string = 'NaN';

    @DisplayOrder(6)
    @TableDisplayedDefault
    @String('Subscription')
    subscriptionStateLabel: string = 'NaN';

    @DisplayOrder(7)
    @TableDisplayedDefault
    @String('Blocked')
    blockedLabel: string = 'NaN';

    @DisplayOrder(8)
    @TableDisplayedDefault
    @String('Entries Today')
    entriesTodayLabel: string = 'NaN';

    @DisplayOrder(9)
    @TableDisplayedDefault
    @Number('Deposit')
    deposit: number = 0;

    @DisplayOrder(10)
    @TableDisplayedDefault
    @Number('Available Balance')
    availableBalance: number = 0;

    cardGuid: string = '';
    balance: number = 0;
    rawSubscriptionState: 'subscribed' | 'suspended' | 'NaN' = 'NaN';
    rawBlocked: boolean | null = null;

    constructor(obj: Partial<CrudAtokuUser> = {}) {
        Object.assign(this, obj);
    }
}
